export default __webpack_public_path__ + "static/media/DHL-ALEMANIA-WASH.9b44b391.svg";